import { APMFilterService } from './apmFilterService';
import { APMQueryService } from './apmQueryService';

angular
    .module('signalview.detector.signal', [])
    .service('apmFilterService', APMFilterService)
    .service('apmQueryService', APMQueryService);
